
const elementosMapaSigStore = {
    namespaced: true,
    state: () => ({
        poligonos: null,
        circulos: null,
        centroMapa: null,
        zoom: null,
    }),
    mutations: {
        //mutacion para ingresar las aplicaciones del cliente
        actualizarElementosMapaSig(state, payload) {
            state.poligonos = payload.poligonos;
            state.circulos = payload.circulos;
            state.centroMapa = payload.centroMapa;
            state.zoom = payload.zoom;
        }
    },

    getters: {
        obtenerElementos(state) {
            return state.aplicacionesCliente;
        }
    },
}

export default elementosMapaSigStore